import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Customer } from '@df/session/api/customer';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { LocalCustomerModel } from '../../../customer/customer.model.decorator';
import { NAntavo } from '../../../module/antavo/antavo.interface';
import { AntavoService } from '../../../module/antavo/antavo.service';
import { NProfiles } from './profile.interfaces';

export interface IAccountProfilesResolverData {
    mission?: NAntavo.IChallenge;
    showBanner: boolean;
    profileData: NProfiles.IProfileData;
}

/**
 * Resolver to load CMS block and mission data for the account profiles page
 */
export const accountProfilesResolver: ResolveFn<IAccountProfilesResolverData> = async () => {
    const antavoService = inject(AntavoService);
    const customer = inject(Customer);
    const iCmsBlockResource = inject(ICmsBlockResource);

    // Load CMS block
    await iCmsBlockResource.retrieve({ bareUrl: NProfiles.COMPONENT_IDS.accountProfiles }, undefined);

    // Load customer model
    const customerModel = (await customer.model.load()) as LocalCustomerModel;

    // Initialize profile data
    let profileData: NProfiles.IProfileData = {};

    // Parse existing profile data from customer attributes
    const profileJson = customerModel.data.customer_profile;
    if (profileJson) {
        try {
            profileData = JSON.parse(profileJson);
        } catch (error) {
            console.error('Failed to parse customer profile data:', error);
            profileData = {};
        }
    }

    let mission: NAntavo.IChallenge | undefined;
    let showBanner = false;

    try {
        mission = await antavoService.getProfileMission();
        showBanner = !!mission && mission.completions !== 1;
    } catch (error) {
        console.error('Failed to load profile mission:', error);
    }

    return {
        mission,
        showBanner,
        profileData
    };
};
